module.exports = __webpack_public_path__ + "img/stock2.409023d3.png";